module.exports = __webpack_public_path__ + "static/media/lion_new.e4abbed4.svg";